import { configApi } from '../http-client.js'

export const getDataProcesses = languageId => {
	const params = languageId !== undefined ? { languageId } : {}
	return configApi.get('/api/DataProcesses', { params })
}
